module.exports = __webpack_public_path__ + "29b169626d7fb670e92c1d9e97456c13.svg";